// Protège React contre les mutations DOM externes (Google Translate / navigateur intégré Gmail, extensions) :
// « NotFoundError: The object can not be found here » / « removeChild: not a child » lors de la navigation.
if (typeof Node === "function" && Node.prototype) {
  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console && process.env.NODE_ENV !== "production") console.warn("removeChild ignoré : nœud déplacé par un script externe (traduction ?)", child);
      return child;
    }
    return origRemoveChild.apply(this, arguments);
  };
  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console && process.env.NODE_ENV !== "production") console.warn("insertBefore ignoré : nœud de référence déplacé par un script externe (traduction ?)", referenceNode);
      return newNode;
    }
    return origInsertBefore.apply(this, arguments);
  };
}
